<template>
  <b-card>
    <b-row>
      <b-col md="4">
        <b-form-group>
          <b-form-select
            v-model="filter2"
            :options="select.filterOptions"
            required
            class="input-new"
            @change="resetFilter"
          />
        </b-form-group>
      </b-col>
      <b-col md="4">
        <b-input-group v-if="filter2 === '1'">
          <b-form-input
            v-model="form.date"
            type="date"
            id="filterInput"
            placeholder="Type to Search"
            class="input-new"
            @click="resetIndex"
          ></b-form-input>
        </b-input-group>
      </b-col>
      <b-col md="4">
        <b-form-group>
          <b-button
            variant="primary"
            class="input-new"
            v-if="filter2 !== null"
            @click="onClickSearch"
            >SEARCH</b-button
          >
          &nbsp;&nbsp;&nbsp;
          <b-button
            variant="warning"
            class="input-new"
            v-if="filter2 !== null"
            @click="clearFilter"
            >CLEAR</b-button
          >
        </b-form-group>
      </b-col>
    </b-row>

    <!-- TABLE -->

    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
      id="my-table"
    >
      <template v-slot:cell(index)="data">
        {{ pagination.startIndex + data.index }}
      </template>
      <template v-slot:cell(date)="data">
        {{ moment(data.value).format("DD/MM/YYYY") }}
      </template>
      <template v-slot:cell(action)="data">
        <span>
          <b-button
            variant="primary"
            size="sm"
            @click="onClickEdit(data.item.id)"
            v-if="data.item.statusid === 4"
            >Edit</b-button
          >
          &nbsp; &nbsp; &nbsp; &nbsp;
          <b-button
            variant="primary"
            size="sm"
            @click="onClickView(data.item.id)"
            v-if="data.item.statusid === 5"
            >View</b-button
          >
          &nbsp; &nbsp; &nbsp; &nbsp;
          <b-button
            variant="primary"
            size="sm"
            @click="onClickDO(data.item.id)"
            v-if="data.item.statusid === 5"
            >DELIVERY ORDER</b-button
          >
        </span>
      </template>
    </b-table>
    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="sm" @click="nextPO">
          CREATE PURCHASE ORDER
        </b-button>
      </b-col>
    </b-row>
    <b-pagination
      v-if="!isLoading"
      v-model="pagination.current"
      :total-rows="pagination.total"
      :per-page="pagination.perPage"
      @change="onChangePage"
    ></b-pagination>
  </b-card>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      moment: moment,
      pro_cat: "1",
      items: [],
      select: {
        filterOptions: [
          { text: "Please Select", value: null },
          { text: "Date", value: "1" }
        ]
      },
      indexsearch: 1,
      filter2: null,
      form: {
        date: null,
        page: 1
      },
      pagination: {
        total: 0,
        current: 1,
        perPage: 10,
        startIndex: 0
      },

      // Loader
      isLoading: false
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  mounted() {},
  created() {
    if (this.filter) {
      this.filter2 = this.filter !== "null" ? this.filter : null;
      this.pagination.current = this.page !== "null" ? this.page : null;
      this.indexsearch = this.page !== "null" ? this.page : null;
      this.form.date = this.date !== "null" ? this.date : null;

      if (this.filter !== "null") {
        this.onClickSearch();
      } else {
        this.pagination.current = this.page !== "null" ? this.page : null;
        this.getPO();
      }
    } else {
      this.getPO();
    }
  },
  props: {
    fields: {
      type: Array,
      required: true
    },

    filter: {
      type: String,
      default: null
    },
    page: {
      type: String
    },
    date: {
      type: String
    }
  },
  methods: {
    onClickView(id) {
      this.$router.push({
        path: `viewPOUser?id=${id}&cat=2&page=${this.pagination.current}&filter=${this.filter2}&date=${this.form.date}`
      });
    },
    onClickPO() {
      // this.$bvModal.show("choose-category");
    },
    close() {
      this.$bvModal.hide("choose-category");
    },
    onClickDO(id) {
      this.$router.push({
        path: `createdo?id=null&cat=4&type=new&purchaseid=${id}`
      });
    },
    onClickEdit(id) {
      // this.$bvModal.hide("choose-category");
      this.$router.push({
        path: `createPO?id=${id}&cat=2&type=update`
      });
    },
    nextPO() {
      // this.$bvModal.hide("choose-category");
      this.$router.push({
        path: `createPO?cat=2&type=new`
      });
    },
    resetFilter() {
      this.form.date = null;
    },
    clearFilter() {
      this.filter2 = null;
      this.form.date = null;
      this.pagination.current = 1;
      this.getPO();
    },
    resetIndex() {
      this.indexsearch = 1;
    },
    onClickSearch() {
      this.isLoading = true;
      this.form.page = this.indexsearch;
      if (this.filter2 === null) {
        this.getPO();
      } else {
        this.$store.dispatch("searchPO", this.form).then(res => {
          this.isLoading = false;
          this.items = [];
          res.data.data.data.forEach(element => {
            this.items.push({
              date: element.date,
              type: element.type,
              status: element.status_details.desc,
              statusid: element.status,
              id: element.purchase_id
            });
          });
          this.pagination.total = res.data.data.total;
          this.pagination.current = res.data.data.current_page;
          this.pagination.perPage = res.data.data.per_page;
          this.pagination.startIndex = res.data.data.from;
          this.indexsearch = res.data.data.current_page;
        });
      }
    },
    getPO() {
      this.isLoading = true;

      this.$store.dispatch("getPOList", this.pagination.current).then(res => {
        this.isLoading = false;
        this.items = [];

        res.data.data.data.forEach(element => {
          this.items.push({
            date: element.date,
            type: element.type,
            status: element.status_details.desc,
            statusid: element.status,
            id: element.purchase_id
          });
        });
        this.pagination.total = res.data.data.total;
        this.pagination.current = res.data.data.current_page;
        this.pagination.perPage = res.data.data.per_page;
        this.pagination.startIndex = res.data.data.from;
      });
    },
    onChangePage(index) {
      this.pagination.current = index;
      this.getPO();
      if (this.filter2 === null) {
        this.getPO();
      } else {
        this.indexsearch =
          this.pagination.current !== this.indexsearch
            ? this.pagination.current
            : this.indexsearch++;
        this.onClickSearch();
      }
    }
  }
};
</script>
<style lang="css" scoped></style>
